<template>
  <v-container class="max-width py-0 align-center text-center">
    <v-row class="text-center pa-0 ma-0">
      <v-col cols="12" class="text-center pa-0 ma-0">
        <v-pagination
          v-if="resourceSettings.pagination && resource && resource.last_page"
          v-model="resource.current_page"
          class="my-0"
          :total-visible="7"
          color="primary"
          @input="pageByNumber"
          :length="resource.last_page"
        >
        </v-pagination>
      </v-col>
      <v-col cols="12" class="text-center pa-0 ma-0" 
        v-if="resourceSettings.pagination && resource && resource.last_page"
      >
        <v-btn color="success" @click="loadResource()" x-small text>reload</v-btn>
        <v-btn color="primary" @click.prevent="createResource" x-small text>create</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props:['resourceSettings', 'resource'],
  methods:{
    createResource() {
      this.$emit('createResource')
    },
    loadResource() {
      this.$emit('loadResource')
    },
    pageByNumber(n) {
      this.$emit('pageByNumber', n)
    }
  },
  computed:{
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
  }
}
</script>

<style>

</style>